import React from "react";
import { LoadingOutlined } from '@ant-design/icons';

const CircularProgress = ({className}) => <div className={`loader ${className}`}>
  <LoadingOutlined style={{fontSize:50,color:'#1890ff'}} />
  {/* <img src="/assets/images/loader.svg" alt="loader"/> */}
</div>;
export default CircularProgress;
